import { FormControl, Typography } from '@mui/material';
import clsx from 'clsx';
import { ErrorMessage } from '@hookform/error-message';
import { Checkbox } from '../../Checkbox';
import { ReactComponent as ImageS } from '../../../assets/icons/ImageS.svg';
import { ReactComponent as ImageSChecked } from '../../../assets/icons/ImageSChecked.svg';
import { ReactComponent as ImageT } from '../../../assets/icons/ImageT.svg';
import { ReactComponent as ImageTChecked } from '../../../assets/icons/ImageTChecked.svg';
import { ReactComponent as ImageQ } from '../../../assets/icons/ImageQ.svg';
import { ReactComponent as ImageQChecked } from '../../../assets/icons/ImageQChecked.svg';
import { ReactComponent as ImageD } from '../../../assets/icons/ImageD.svg';
import { ReactComponent as ImageDChecked } from '../../../assets/icons/ImageDChecked.svg';
import { Controller, Validate, useFormContext } from 'react-hook-form';

export interface WeekdaysFormProps {
  foo?: string;
}

export const WeekdaysForm = ({}: WeekdaysFormProps): JSX.Element => {
  const methods = useFormContext();
  const name = 'weekdays';

  const validateWeekdays: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Validate<any> | Record<string, Validate<any>> = () => {
    const recurrences: Record<string, boolean> = methods.getValues(name);
    const isValid = Object.values(recurrences).reduce(
      (acc, recurrence) => acc || recurrence,
      false
    );
    !isValid
      ? methods.setError(name, {
          message: 'Escolha pelo menos um dia da semana',
        })
      : methods.clearErrors(name);
    return isValid;
  };

  return (
    <FormControl component="fieldset">
      <Typography
        className={clsx(
          { 'text-mui-error': methods.formState.errors[name] },
          'mb-1 font-bold'
        )}
        alignSelf="start"
      >
        Repetir:
      </Typography>
      <Controller
        name={name}
        render={({ formState: { errors } }) => (
          <>
            <div aria-labelledby={name} className="flex">
              <Checkbox
                title="Domingo"
                rules={{ validate: validateWeekdays }}
                labelClassName="m-0"
                name={name + '.sunday'}
                icon={<ImageD />}
                checkedIcon={<ImageDChecked />}
              />
              <Checkbox
                title="Segunda-feira"
                rules={{ validate: validateWeekdays }}
                labelClassName="m-0"
                name={name + '.monday'}
                icon={<ImageS />}
                checkedIcon={<ImageSChecked />}
              />
              <Checkbox
                title="Terça-feira"
                rules={{ validate: validateWeekdays }}
                labelClassName="m-0"
                name={name + '.tuesday'}
                icon={<ImageT />}
                checkedIcon={<ImageTChecked />}
              />
              <Checkbox
                title="Quarta-feira"
                rules={{ validate: validateWeekdays }}
                labelClassName="m-0"
                name={name + '.wednesday'}
                icon={<ImageQ />}
                checkedIcon={<ImageQChecked />}
              />
              <Checkbox
                title="Quinta-feira"
                rules={{ validate: validateWeekdays }}
                labelClassName="m-0"
                name={name + '.thursday'}
                icon={<ImageQ />}
                checkedIcon={<ImageQChecked />}
              />
              <Checkbox
                title="Sexta-feira"
                rules={{ validate: validateWeekdays }}
                labelClassName="m-0"
                name={name + '.friday'}
                icon={<ImageS />}
                checkedIcon={<ImageSChecked />}
              />
              <Checkbox
                title="Sábado"
                rules={{ validate: validateWeekdays }}
                labelClassName="m-0"
                name={name + '.saturday'}
                icon={<ImageS />}
                checkedIcon={<ImageSChecked />}
              />
            </div>
            <ErrorMessage
              name={name}
              errors={errors}
              render={({ message }) => (
                <Typography
                  className={clsx(
                    { 'text-mui-error': errors[name] },
                    'ml-4 mb-1'
                  )}
                  alignSelf="start"
                >
                  {message}
                </Typography>
              )}
            />
          </>
        )}
      />
    </FormControl>
  );
};
